import React, { useState, useEffect } from "react";
import GaugeCard from "./GaugeCard";
// import GaugeCard from "../NewApplication/GaugeCard";
import _NewapplicationService from "../../modules/NewapplicationService";
import { Card, Row, Col, Typography, Divider, Space, Button, Tag, List, Spin, Modal, message, Tooltip, Table } from "antd";
import _commonService from "../../modules/commonService";
import {
  BarChart, Bar, XAxis, YAxis, LabelList, Cell, ResponsiveContainer
} from 'recharts';
import { DollarOutlined, DashboardOutlined, LineChartOutlined } from "@ant-design/icons";
import { useLocation } from "react-router-dom";
import SummaryTermsProjectedInterest from "./SummaryTermsProjectedInterest";
import {
  LOAN_OFFICER_ROLE,
  SENIOR_PRIVATE_BANKER_ROLE,
  UNDERWRITER_BANKER_ROLE,
  PRIVATE_WEALTH_ADVISOR_ROLE,
  COMPLIANCE_ADMINISTRATOR_ROLE,
} from "../../constants/DataConstants";

// RoleMaster Ids 2,3,4,5,8 -- the Banker-family roles that reach this screen via
// BankerUI/LoanApplicationDetails.js. Applicant/Client never lands here (they use
// NewApplication/AssessmentTab.js instead), but the explicit role check keeps this call site
// correct on its own rather than relying only on which page happens to mount it.
const BANKER_FAMILY_ROLES = [
  LOAN_OFFICER_ROLE,
  SENIOR_PRIVATE_BANKER_ROLE,
  UNDERWRITER_BANKER_ROLE,
  PRIVATE_WEALTH_ADVISOR_ROLE,
  COMPLIANCE_ADMINISTRATOR_ROLE,
];

const { Text, Title } = Typography;


// export const CBR_RANGES = [
//   { limit: 20, color: "#7F1D1D" },  // Very Low
//   { limit: 40, color: "#B91C1C" },  // Low
//   { limit: 60, color: "#3ef797" },  // Medium
//   { limit: 80, color: "#00c046" },  // Good
//   { limit: 100, color: "#00ff5e" }, // High
// ];

// export const TDSR_RANGES = [
//   { value: 20, color: "#22C55E" },  // Low debt (Excellent)
//   { value: 65, color: "#EAB308" },  // Moderate debt
//   { value: 100, color: "#EF4444" }, // High debt (Risk)
// ];

// export const LEVERAGE_RANGES = [
//   { value: 0.75, color: "#22C55E" },  // Low (Healthy)
//   { value: 1.75, color: "#EAB308" },  // Moderate
//   { value: 3, color: "#EF4444" },     // High (Risk)
// ];

export const CBR_RANGES = [
  { value: 579, color: "#2A4A53" },  // Poor (Professional Red)
  { value: 669, color: "#427471" },  // Fair (Warm Amber)
  { value: 739, color: "#9FC7FF" },  // Good (Soft Blue)
  { value: 799, color: "#00E3C4" },  // Very Good (Teal)
  { value: 900, color: "#16A34A" },  // Excellent (Deep Green)
];

export const TDSR_RANGES = [
  { value: 20, color: "#16A34A" },   // Low (Healthy)
  { value: 65, color: "#00E3C4" },   // Moderate
  { value: 100, color: "#2A4A53" },  // High Risk
];

export const LEVERAGE_RANGES = [
  { value: 0.75, color: "#16A34A" },  // Low Leverage
  { value: 1.75, color: "#00E3C4" },  // Moderate
  { value: 3, color: "#2A4A53" },     // High Risk
];

const AssessmentTab = ({ activeKey, ApplicationObjId }) => {
  const [loading, setLoading] = useState(false);
  const [assesmentInfo, setAssesmentInfo] = useState({});

  useEffect(() => {
    if (activeKey && activeKey == "1") {
      getApplicantAssesmentInfoByApplicationId(Number(ApplicationObjId));
    }
  }, [activeKey]);

  const getApplicantAssesmentInfoByApplicationId = async (ApplicationObjId) => {
    setLoading(true);
    try {
      const userRole = localStorage.getItem("userRole");
      const res = BANKER_FAMILY_ROLES.includes(userRole)
        ? await _NewapplicationService.getApplicantAssesmentInfoByApplicationIdWithBankerAdjustment(Number(ApplicationObjId))
        : await _NewapplicationService.getApplicantAssesmentInfoByApplicationId(Number(ApplicationObjId));
      if (res.data) {
        let resObj = res.data.Obj;
        localStorage.setItem("ApplicantName", resObj.applicantGeneralInfoModel ? `${resObj.applicantGeneralInfoModel.FirstName || ""} ${resObj.applicantGeneralInfoModel.LastName || ""}`.trim() : "");

        setAssesmentInfo(resObj);
        setLoading(false);
      }
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };

  // Parse values for table
  const currentValueForTable = assesmentInfo && assesmentInfo.Current;
  const proFormaValueForTable = assesmentInfo && assesmentInfo.PostLoan;

  let currentPercentForTable = 'N/A', currentAmountForTable = 'N/A', proFormaPercentForTable = 'N/A', proFormaAmountForTable = 'N/A';
  if (currentValueForTable) {
    const [percent, amount] = currentValueForTable.split(', ');
    currentPercentForTable = percent ? percent.trim() : 'N/A';
    currentAmountForTable = amount ? amount.trim() : 'N/A';
  }
  if (proFormaValueForTable) {
    const [percent, amount] = proFormaValueForTable.split(', ');
    proFormaPercentForTable = percent ? percent.trim() : 'N/A';
    proFormaAmountForTable = amount ? amount.trim() : 'N/A';
  }


  // console.log("assesmentInfo", assesmentInfo);

  // const safeLimitValue = assesmentInfo && assesmentInfo.SafeLimit;
  const currentValue = assesmentInfo && assesmentInfo.Current;
  const proFormaValue = assesmentInfo && assesmentInfo.PostLoan;

  // Extract numeric part before %
  // const safeLimitPercent = parseFloat(safeLimitValue && safeLimitValue.split('%')[0]);
  const currentPercent = parseFloat(currentValue && currentValue.split('%')[0]);
  const proFormaPercent = parseFloat(proFormaValue && proFormaValue.split('%')[0]);

  // Calculate difference
  // const differencePercent = safeLimitPercent - currentPercent;


  const maxValue = Math.max(currentPercent, proFormaPercent, 1);

  const barData = [
    {
      name: 'Current',
      value: currentPercent,
      // safeLimitAmount: 400000,
      color: '#93C5FD',
    },
    {
      name: 'Pro-Forma',
      // safeLimit: safeLimitPercent,
      proForma: proFormaPercent,
      // currentAmount: 105000,
      // postLoanAmount: 500000,
    }
  ];

  const makeCenteredData = (value) => [
    {
      name: 'bar',
      leftPad: (maxValue - value) / 2,
      value,
      rightPad: (maxValue - value) / 2
    }
  ];
  return (
    <Spin spinning={loading}>


      <Card className="card-section mb10 assessment-tab">
        <div className="chartbox-title">
          <DashboardOutlined className="chartbox-title-icon" />
          Key Metrics
        </div>
      <Row gutter={[16, 16]} 
          className="metrics-row">
        <Col
            xs={24}
            sm={12}
            md={8}
            className="chartbox1"
        >
          <>
            {/* <GaugeCard label="CBR Score" value={Number(assesmentInfo && assesmentInfo.CBRScore)} min={300} max={850} description={assesmentInfo && assesmentInfo.CBRScoreStaus} /> */}
            <GaugeCard
              label="CBR Score"
              value={Number(assesmentInfo && assesmentInfo.CBRScore)}
              minValue={500}
              maxValue={900}
              threshold={assesmentInfo && assesmentInfo.SponserCBR}
              higherIsBetter
              withinLabel="Over threshold"
              overLabel="Within criteria"
              withinDiffWord="Over"
              overDiffWord="within"
              description={assesmentInfo && assesmentInfo.CBRScoreStaus}
            />
          </>
        </Col>

        <Col
            xs={24}
            sm={12}
            md={8}
            className="chartbox1"
        >
          <>
            {/* <GaugeCard label="TDSR %" value={assesmentInfo && assesmentInfo.PFTDSR ? assesmentInfo.PFTDSR : "N/A"} min={0} max={100} unit=" %" description={assesmentInfo && assesmentInfo.TDSRStatus} /> */}
            <GaugeCard
              label="TDSR %"
              value={assesmentInfo && assesmentInfo.PFTDSR ? assesmentInfo.PFTDSR : 0}
              minValue={0}
              maxValue={100}
              unit="%"
              threshold={assesmentInfo && assesmentInfo.SponserTDSR}
              description={assesmentInfo && assesmentInfo.TDSRStatus}
            />

          </>
        </Col>


        <Col
            xs={24}
            sm={12}
            md={8}
            className="chartbox1"
        >
          <>
            {/* <GaugeCard label="Leverage" value={assesmentInfo && assesmentInfo.Levrage ? assesmentInfo.Levrage : "N/A"} min={0} max={2} description={assesmentInfo && assesmentInfo.LevridgeStatus} /> */}
            <GaugeCard
              label="Leverage"
              value={assesmentInfo && assesmentInfo.Levrage ? assesmentInfo.Levrage : 0 }
              minValue={0}
              maxValue={3}
              threshold={assesmentInfo && assesmentInfo.SponserLevrage}
              description={assesmentInfo && (assesmentInfo.LeverageStatus || assesmentInfo.LevridgeStatus || assesmentInfo.LevrageStatus)}
            />
          </>
        </Col>


      </Row>

      </Card>




      <Row gutter={[12, 12]} className="iconFont assessment-tab-details">
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>

          <Card className="card-section">
            {/* <div className="spaceFlex">
              <h3 style={{ fontSize: 16, marginBottom: 16, color: "#414957" }}>Debt Proforma Impact</h3>
              <Tooltip title={`What is Debt Proforma Impact?`}>
                <QuestionCircleOutlined />
              </Tooltip>
            </div> */}

            <div className="chartbox-title">
              <LineChartOutlined className="chartbox-title-icon" />
              Debt Proforma Impact
            </div>

            <Table
              bordered={false}
              pagination={false}
              className="transparent-table"
              columns={[
                {
                  title: 'Metric',
                  dataIndex: 'metric',
                  key: 'metric',
                  render: text => <span className="spanColor">{text}</span>,
                },
                {
                  title: 'Current',
                  dataIndex: 'current',
                  key: 'current',
                },
                {
                  title: 'Pro-Forma',
                  dataIndex: 'proForma',
                  key: 'proForma',
                },
              ]}
              dataSource={[
                {
                  key: '1',
                  metric: 'Total Debt Service ($)',
                  current: currentAmountForTable,
                  proForma: proFormaAmountForTable,
                },
                {
                  key: '2',
                  metric: 'Debt-to-Income Ratio (%)',
                  current: currentPercentForTable,
                  proForma: proFormaPercentForTable,
                },
              ]}
              showHeader={true}
              size="small"
            />


            <Row justify="center" gutter={32} className="responsivechartcontainer">

              {/* CURRENT */}
              <Col>
                <div className="chartWrapperStyle">
                  <ResponsiveContainer width="100%" height={60}>
                    <BarChart
                      data={makeCenteredData(currentPercent)}
                      layout="vertical"
                      barCategoryGap={20}
                      barGap={0}
                      margin={{ top: 0, right: 0, left: 0, bottom: 0 }}
                    >
                      <XAxis type="number" hide domain={[0, maxValue]} />
                      <YAxis type="category" hide />

                      {/* Left padding */}
                      <Bar dataKey="leftPad" stackId="a" fill="transparent" />

                      {/* Actual bar */}
                      <Bar
                        dataKey="value"
                        stackId="a"
                        barSize={14}
                        radius={[8, 8, 0, 0]}
                        fill="rgba(244, 244, 245, 0.1)"
                        height={20}
                      />

                      {/* Right padding */}
                      <Bar dataKey="rightPad" stackId="a" fill="transparent" />
                    </BarChart>
                  </ResponsiveContainer>

                  <div style={{ color: 'rgba(244,244,245,0.7)', fontSize: 12 }}>Current</div>
                  <div style={{ color: 'rgba(244,244,245,0.7)', fontSize: 12 }}>
                    {currentValueForTable}
                  </div>
                </div>
              </Col>
              


              {/* PRO-FORMA */}
              <Col>
                <div className="chartWrapperStyle">
                  <ResponsiveContainer width="100%" height={60}>
                    <BarChart data={makeCenteredData(proFormaPercent)}
                      layout="vertical"
                      barCategoryGap={20}
                      barGap={0}
                      margin={{ top: 0, right: 0, left: 0, bottom: 0 }}
                    >
                      <XAxis type="number" hide domain={[0, maxValue]} />
                      <YAxis type="category" hide />

                      <Bar dataKey="leftPad" stackId="a" fill="transparent" />

                      <Bar
                        dataKey="value"
                        stackId="a"
                        barSize={20}
                        radius={[8, 8, 0, 0]}
                        fill="rgba(234, 179, 8, 1)"
                      />

                      <Bar dataKey="rightPad" stackId="a" fill="transparent" />
                    </BarChart>
                  </ResponsiveContainer>

                  <div style={{ color: 'rgba(244,244,245,0.7)', fontSize: 12 }}>Pro-Forma</div>
                  <div style={{ color: 'rgba(244,244,245,0.7)', fontSize: 12 }}>
                    {proFormaValueForTable}
                  </div>
                </div>
              </Col>


            </Row>

            {/* <BarChart
              layout="vertical"
              width={350}
              height={100}
              data={barData}
              margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
              barCategoryGap={0}
              barGap={0}
            >
              <XAxis type="number" domain={[0, 50]} hide />
              <YAxis type="category" dataKey="name" width={100} /> */}
              {/* <Tooltip content={<CustomTooltip />} /> */}
              {/* <Bar stackId="a" dataKey="value" barSize={30}>
                {
                  barData && barData.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={entry.color || '#00FFE0'} />
                  ))
                }
                <LabelList
                  dataKey="value"
                  position="right"
                  formatter={() => ""}
                  style={{ fill: '#000', fontWeight: 600 }}
                />
              </Bar> */}
              {/* <Bar dataKey="safeLimit" stackId="a" barSize={20} fill="#00FFE0">
              <LabelList
                dataKey="safeLimit"
                position="right"
                formatter={() => ""}
                style={{ fill: '#000', fontWeight: 600 }}
              />
            </Bar> */}
              {/* <Bar dataKey="proForma" stackId="a" barSize={30} fill="#3B28CC">
                <LabelList
                  dataKey="proForma"
                  position="right"
                  // formatter={(val) =>
                  //   `${val}%`
                  // }
                  formatter={() => ""}
                  style={{ fill: '#000', fontWeight: 600 }}
                />
              </Bar>
            </BarChart> */}

            {/* <div style={{ fontSize: 14, lineHeight: '1.6', marginTop: 16 }}>
              {[
                // { label: 'Safe Limit', value: assesmentInfo?.SafeLimit, color: '#00FFE0' },
                { label: 'Current', value: assesmentInfo?.Current, color: '#93C5FD' },
                { label: 'Pro-Forma', value: assesmentInfo?.PostLoan, color: '#3B28CC' },
              ].map((item, idx) => (
                <div
                  key={idx}
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    marginBottom: 4,
                    alignItems: 'center',
                    margin: '5px'
                  }}
                >
                  <span className="mw80 spanColor">
                    <span style={{ color: item.color, marginRight: 6 }}>■</span>
                    {item.label}
                  </span>
                  <span>{item.value ?? 'N/A'}</span>
                </div>
              ))}
            </div> */}


            {/* <div style={{ textAlign: 'center', marginTop: 16 }}>
              <div style={{ display: 'inline-grid', textAlign: 'left', fontSize: 14, lineHeight: '1.6' }}>
                <span className="spanColor">
                  <span style={{ marginRight: 8 }}>•</span>
                  Total Debt Service ($)
                </span>
                <span className="spanColor">
                  <span style={{ marginRight: 8 }}>•</span>
                  Debt-to-Income Ratio (%)
                </span>
              </div>
            </div> */}

          </Card>
        </Col>

        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <Card
            className="card-section financial-snapshot-card"
            style={{ height: "100%" }}
          >
            {/* <div className="financial-header">
              <DollarOutlined className="financial-icon" />
              <span>Financial Snapshot</span>
            </div> */}

            <div className="chartbox-title">
              <DollarOutlined className="chartbox-title-icon" />
              Financial Snapshot
            </div>




            <span>Total Debt Service</span><span className="fRight">{assesmentInfo && assesmentInfo.TotalDebtService ? `$ ${_commonService.formatNumberWithCommas(assesmentInfo.TotalDebtService)}` : "N/A"}</span>
            <Divider className="divider" />
            <span>Total Existing Debt</span><span className="fRight">{assesmentInfo && assesmentInfo.TotalExistingDebt ? `$ ${_commonService.formatNumberWithCommas(assesmentInfo.TotalExistingDebt)}` : "N/A"}</span>
            <Divider className="divider" />
            <span>Total Income</span><span className="fRight">{assesmentInfo && assesmentInfo.TotalIncome ? `$ ${_commonService.formatNumberWithCommas(assesmentInfo.TotalIncome)}` : "N/A"}</span>
            <Divider className="divider" />
            <span>Total Assets</span><span className="fRight">{assesmentInfo && assesmentInfo.AssetsValuation ? `$ ${_commonService.formatNumberWithCommas(assesmentInfo.AssetsValuation)}` : "N/A"}</span>
            <Divider className="divider" />
            <span>Net Worth</span><span className="fRight">{assesmentInfo && assesmentInfo.NetWorth ? `$ ${_commonService.formatNumberWithCommas(assesmentInfo.NetWorth)}` : "N/A"}</span>
            <Divider className="divider" />
            <span>Debt-to-Income Ratio</span><span className="fRight">{assesmentInfo && assesmentInfo.DebtIncomeRatio ? `${assesmentInfo.DebtIncomeRatio} %` : "N/A"}</span>
          </Card>
        </Col>
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <SummaryTermsProjectedInterest ApplicationObjId={ApplicationObjId} />
        </Col>
      </Row>

    </Spin>
  )
};

export default AssessmentTab;